import { createReducer, on, Action } from '@ngrx/store';
import { Ranking } from '../../models/rankings.models';

import * as StateRankingsActions from './rankings-category.actions';

export const _STATE_RANKINGS_CATEGORY_FEATURE_KEY = 'stateRankingsCategory';

export interface State {
	rankings: Ranking[];
	loaded: boolean; // has the StateRankingsCategory list been loaded
	error?: any; // last known error (if any)
}

export interface StateRankingsCategoryPartialState {
	readonly [_STATE_RANKINGS_CATEGORY_FEATURE_KEY]: State;
}

export const initialState: State = {
	// set initial required properties
	loaded: false,
	rankings: [],
};

const stateRankingsReducer = createReducer(
	initialState,
	on(StateRankingsActions.fetchRankingsList, (state) => ({
		...state,
		error: null,
	})),
	on(StateRankingsActions.updateRankingsList, (state, stateRankings) => ({
		...state,
		loaded: true,
		rankings: stateRankings,
	})),
	on(StateRankingsActions.loadStateRankingsFailure, (state, { error }) => ({
		...state,
		error,
	})),
);

export function reducer(state: State | undefined, action: Action) {
	return stateRankingsReducer(state, action);
}
